import React, { memo } from "react";
import { formatDateTime } from "../../utils/date";

const ListSmsSendings = ({ sms_sendings }) => {
    console.count('ListSmsSendings')
  return (
    <tbody>
      {sms_sendings
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map((item) => {
          return (
            <tr
              key={item.id}
              style={{
                borderLeft: `2px solid ${item.sended_at ? "green" : "red"}`,
              }}
            >
              <td style={{ width: "35%" }}>
                {formatDateTime(item.created_at)}
                <br />
                <div>{item.user_title}</div>
              </td>
              <td>{item.body}</td>
            </tr>
          );
        })}
    </tbody>
  );
};

export default memo(ListSmsSendings);
